<template>
  <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5">
    <div class="col-span-1 md:mr-4 box flex flex-col justify-center">
      <div class="w-full h-auto bg-white flex flex-row justify-center p-4">
        <img :src="imgLogo" class="" alt="" />
      </div>
    </div>
    <div class="col-span-2 lg:col-span-4 mt-4 md:mt-0">
      <div class="intro-y box p-5">
        <div class="flex lg:space-x-4 flex-col lg:flex-row">
          <div class="text-theme-6">ตำแหน่งเอกสาร : {{ statusName }}</div>
          <div class="text-theme-10">ผู้ดำเนินการ : {{ participants }}</div>
        </div>
      </div>
      <div class="intro-y box p-5 mt-5 flex justify-between">
        <div>
          <div>สายอนุมัติของผู้เปิดเอกสาร :</div>
          <div class="font-bold">
            {{ documentPath.length ? documentPath.join(' -> ') : '' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs } from 'vue'

export default defineComponent({
  props: {
    imgLogo: {
      type: String,
      default: () => null
    },
    statusName: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    participants: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    documentPath: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    return {
      ...toRefs(props)
    }
  }
})
</script>

<style scoped></style>
